import AppRoutes from './AppRoutes'
import { customBrandTheme } from './theme'
import { useBrand } from './stores/brand-store'
import Loading from './components/layouts/Loading'
import MuiContainer from './components/containers/MuiContainer'
import { useAuth } from './components/containers/AuthContainer'

function App(): JSX.Element {
  const { isAuthenticated } = useAuth()
  const { data: brand, isLoading } = useBrand({ enabled: isAuthenticated() })
  const customTheme = customBrandTheme(brand)

  return <MuiContainer theme={customTheme}>{isLoading ? <Loading /> : <AppRoutes />}</MuiContainer>
}

export default App
